// extracted by mini-css-extract-plugin
export default {"linkButtonWrapper":"modal_linkButtonWrapper__vwS-I","linkButton":"modal_linkButton__hH702","modal":"modal_modal__AGg2t","wrapper":"modal_wrapper__3LfWi"};